import { IConsentDialogContent } from '../form-consent-checkbox.component';
import { CONSENT_MODAL_LINK_HREF } from '../consent-modal-link.constants';
import { IConsentPresentation, IConsentVariant } from './consent-variant.model';

export abstract class BaseConsentVariant implements IConsentVariant {
    abstract identifier: string;

    createPresentation(): IConsentPresentation {
        return {
            labelHtmlKey: this.labelHtmlKey,
            labelHtmlTranslateParams: {
                consentModalLinkHref: CONSENT_MODAL_LINK_HREF,
            },
            dialogContent: this.dialogContent,
        };
    }

    protected abstract get labelHtmlKey(): string;
    protected abstract get dialogContent(): IConsentDialogContent;
}
